import React, { MouseEventHandler, useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";

export default function CustomWebCam({
  uploadImage,
  discard,
}: {
  uploadImage: Function;
  discard: MouseEventHandler<HTMLButtonElement>;
}) {
  const webcamRef = useRef(null);
  const [imgSrc, setImgSrc] = useState(null);
  const capture = useCallback(() => {
    if (!webcamRef.current) return;
    const imageSrc = (webcamRef.current as any).getScreenshot();
    if (!imageSrc) return;
    setImgSrc(imageSrc);
    uploadImage(imageSrc);
  }, [webcamRef]);

  return (
    <div className="web-cam-container">
      {imgSrc ? (
        <img src={imgSrc} alt="webcam" />
      ) : (
        <Webcam
          width={"100%"}
          ref={webcamRef}
          capture={"environment"}
          videoConstraints={{facingMode:'environment'}}
          screenshotFormat="image/jpeg"
          screenshotQuality={0.8}
          allowFullScreen={true}
          

        />
      )}
      <div className="btn-container">
        <button onClick={capture}>
          <i className="fa-solid fa-camera"></i>
        </button>
        <button className="discard" onClick={discard}>
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
  );
}
